export default "/assets/images/filter-recommandation-BS.6920f5b64fb62a26.jpg";